import type { FC, ReactNode } from "react";
import { Redirect } from "expo-router";

import { api } from "~/utils/api";

export const OnlyAuthorized: FC<{ children: ReactNode }> = ({ children }) => {
  const [isAuthorized] = api.auth.isAuthorized.useSuspenseQuery(undefined);

  if (!isAuthorized) {
    return <Redirect href={"/auth"} />;
  }

  return children;
};
